import { getBlogPageTitle, $loader } from './_helpers';

const initBlogContent = function () {
	const $blogContent = $('#blog-content');
	const $seriesContent = $('#series-content');

	if ($blogContent.length || $seriesContent.length) {
		// Used for blogs page update by AJAX
		$('#page').on(
			'click',
			'.ren-blog__list-paging .page-numbers, .ren-blog__categories .ren-select__item a',
			function (e) {
				e.preventDefault();
				let page;
				// Check if is select (used for switch categories)
				if ($(this).parent().hasClass('ren-select__item')) {
					const $currentSelected = $(
						'.ren-blog__categories .ren-select__current'
					);
					$currentSelected.text($(this).text());
					$currentSelected.attr('id', $(this).attr('id'));
					$('.ren-blog__categories .ren-select__item').removeClass(
						'ren-select__item--selected'
					);
					$(this).parent().addClass('ren-select__item--selected');
					$blogContent.data('category', $(this).attr('id'));
				} else {
					page = parseInt($(this).html());
				}
				const category = $blogContent.data('category');
				const series = $blogContent.data('series');

				const data = {
					action: 'blog-list',
					security: WPvars.nonce
				};
				if (page) {
					data.page = page;
				}
				if (category) {
					data.category = category;
				}
				if (series) {
					data.series = series;
				}

				$.ajax({
					type: 'GET',
					url: WPvars.paths.ajaxURL,
					data,
					beforeSend() {
						$loader.addClass('active');
					},
					success(response) {
						$loader.removeClass('active');
						// Append HTML
						$blogContent.html(response);

						const title = getBlogPageTitle();
						const url = $('.ren-blog__list').data('url');
						// For security reasons, pushState() will not update the URL if it includes a domain,
						// so we're using regex to keep only the path, e.g. /managers/P4.
						const path = url.replace(/https?:\/\/[^\/]+/i, '');

						// Push this page onto the browser history stack for forward/back button functionality.
						history.pushState({}, title, path);

						// Scroll to TOP
						$('html, body').animate({ scrollTop: 0 }, 'fast');
					},
					error() {
						$loader.removeClass('active');
						// eslint-disable-next-line no-console
						console.warn('Fail');
					}
				});
			}
		);
	}
};

export default initBlogContent;
